import AppHeader from "@/components/AppHeader"; // Import header baru
import AppSidebar from "@/components/AppSidebar";
import { SidebarInset } from "@/components/ui/sidebar";
import { Outlet } from "react-router";

export default function MainLayout() {
  return (
    <div className="flex h-screen w-full bg-slate-50 dark:bg-slate-950 overflow-hidden text-slate-900 dark:text-slate-100 font-sans">
      <AppSidebar />
      <SidebarInset className="flex flex-col flex-1 overflow-hidden">
        <AppHeader />

        <main className="flex-1 relative overflow-y-auto bg-white dark:bg-slate-950 p-0 custom-scrollbar">
          <div className="min-h-full p-4 md:p-6 space-y-6 max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </div>
  );
}
